import React, { HTMLAttributes } from 'react';

import clsx from 'clsx';
import Image from 'next/image';

import { routes } from '@routes';

import { link } from '@utils/link';

import { Icon, Link } from '@atoms';

import classes from './nav-logo.module.scss';

export type LogoProps = {
  atlas?: boolean;
  minimal?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const NavLogo = ({ atlas = false, minimal }: LogoProps) => {
  return (
    <Link {...link(routes.homepage)} className={clsx(atlas && classes.atlas)}>
      {/* LOGO IMAGE */}
      <div className={clsx(classes.navLogo, minimal && classes.minimal)}>
        <Image
          width={150}
          height={40}
          src={require('./img/logo.svg')}
          alt=""
          unoptimized
        />
      </div>
      {/* LOGO ICON */}
      {atlas && <Icon icon="logo" className={classes.icon} />}
    </Link>
  );
};
